import "./style.scss"
import "react-toastify/dist/ReactToastify.css"

import React, { lazy, Suspense, useEffect, useState } from "react"
import { toast, ToastContainer } from "react-toastify"
import { useCookieListener } from "tf-checkout-react"

import Logo from "../../assets/images/OpenGround-TypoSymbol.png"
import { ENV } from "../../constants/env"
import { getCookieByName, setCustomCookie } from "../../utils/cookies"
import { setTfCheckoutReactConfigs } from "../../utils/tf-checkout-config"
import Header, { X_TF_ECOMMERCE } from "../header"
import { Loader } from "../loader"

// Lazy load tf-checkout-react components
const ForgotPasswordModal = lazy(() =>
  import("tf-checkout-react").then(module => ({ default: module.ForgotPasswordModal }))
)
const LoginModal = lazy(() => import("tf-checkout-react").then(module => ({ default: module.LoginModal })))

setTfCheckoutReactConfigs()

export const customStyles = {
  content: {
    background: "black",
    position: "unset"
  }
}

const Layout = ({ children, className }) => {
  const [showLogin, setShowLogin] = useState(false)
  const [, setModalName] = useState("login")
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false)
  const [, setError] = useState(null)
  const [isLogged, setIsLogged] = useState(false)
  const [userId, setUserId] = useState(null)

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsLogged(!!getCookieByName(X_TF_ECOMMERCE))
      const params = new URL(window.location.href).searchParams
      const userId = params.get("userId")
      setUserId(userId || "")
    }
  }, [])

  useCookieListener(X_TF_ECOMMERCE, value => setIsLogged(Boolean(value)))

  const onClose = () => {
    setShowLogin(false)
    setModalName("login")
    setError(null)
  }

  const handleOnLogin = e => {
    if (e?.tfResponseHeaders?.["x-tf-ecommerce"]) {
      setCustomCookie("X-TF-ECOMMERCE", e.tfResponseHeaders["x-tf-ecommerce"])
    }
    setShowLogin(false)
    setIsLogged(true)
    setError(null)

    if (typeof window !== "undefined") {
      if (window.location.pathname?.includes("billing")) {
        window.location.reload()
      }
    }
  }

  const [isLoading] = useState(!!userId)

  const getLoginByProvider = function () {
    switch (ENV.AUTH_PROVIDER) {
      case "TTF":
      default:
        return (
          <Suspense fallback={<div>Loading...</div>}>
            <LoginModal
              logo={Logo}
              onClose={onClose}
              onLogin={handleOnLogin}
              onForgotPassword={() => {
                setShowLogin(false)
                setShowResetPasswordModal(true)
              }}
              showForgotPasswordButton
            />
          </Suspense>
        )
    }
  }

  return (
    <>
      <Header setShowLogin={setShowLogin} setIsLogged={setIsLogged} isLogged={isLogged} />
      <main className={`main-layout-content ${className ?? ""}`}>
        {showLogin && !isLogged && getLoginByProvider()}
        {showResetPasswordModal && (
          <Suspense fallback={<div>Loading...</div>}>
            <ForgotPasswordModal
              onClose={() => {
                setShowResetPasswordModal(false)
                setShowLogin(false)
              }}
              onLogin={() => {
                setShowResetPasswordModal(false)
                setShowLogin(true)
              }}
              onForgotPasswordSuccess={data => {
                toast.success(data?.message || "Password reset successfully")
              }}
              onForgotPasswordError={error => {
                toast.error(error?.response?.data?.message || "Password reset failed")
              }}
              onLoginButtonClick={() => {
                setShowResetPasswordModal(false)
                setShowLogin(true)
              }}
              displaySuccessMessage
            />
          </Suspense>
        )}
        {isLoading ? <Loader text="Checking email" /> : children}
      </main>
      <ToastContainer autoClose={10000} />
    </>
  )
}

export default Layout
